import { isChrome, isIOS } from 'react-device-detect';
import styled from 'styled-components';
export const StatusContainer = styled.div `
    flex-grow: 1;
`;
export function resetScroll() {
    if (!isIOS) {
        return;
    }
    window.scrollTo({
        left: 1000,
        top: 1000,
        /*
         * In iOS Chrome (WebKit), smooth scrolling on large scrollable areas (e.g., 10000×10000)
         * can cause memory issues and tab reloads. Prefer 'auto' behavior to avoid crashes.
         */
        behavior: isChrome ? 'auto' : 'smooth',
    });
}
export const BlockedPermissions = styled.div `
    align-items: center;
    background-color: var(--BlockedPermissions_Background, rgba(0, 0, 0, 0.6));
    border-radius: var(--BlockedPermissions_BorderRadius, 1rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 2rem;
    box-sizing: border-box;

    button {
        white-space: initial;
        height: auto;
        min-height: 3.75rem;
        padding-top: 1rem;
        padding-bottom: 1rem;
        line-height: 1.75rem;
        pointer-events: all;
    }
`;
